/* eslint-disable react/jsx-props-no-spreading */
import { Alert, Box, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody } from 'reactstrap';

interface FirstStepInvoiceDateProps {
  setValueStartDate: (value: DateTime | null) => void;
  setValueEndDate: (value: DateTime | null) => void;
}

const FirstStepInvoiceDate = ({
  setValueStartDate,
  setValueEndDate,
}: FirstStepInvoiceDateProps) => {
  const { t } = useTranslation();
  const [noData] = useState<boolean>(false);

  return (
    <ModalBody className="px-2 pb-7">
      <Box className="flex flex-shrink-0 items-center justify-center px-3 pb-7 rounded-t-md">
        <Typography variant="h6">{t('InvoiceExport')}</Typography>
      </Box>
      <Box className="md:w-7/12 w-full mx-auto">
        <Box className="">
          <Box>
            <Typography variant="body1" className="!mb-3">
              {t('generateInvoiceDate')}
            </Typography>
          </Box>
        </Box>
        <Box className="flex">
          <DatePicker
            label={t('startDate')}
            onChange={(newValue) => setValueStartDate(newValue as DateTime)}
            disableFuture
            className="!mr-[10px]"
          />
          <DatePicker
            label={t('endDate')}
            onChange={(newValue) => setValueEndDate(newValue as DateTime)}
            disableFuture
            className="!ml-[10px]"
          />
        </Box>
        {noData && (
          <Alert className="mt-3" severity="warning">
            {t('pyNoData')}
          </Alert>
        )}
      </Box>
    </ModalBody>
  );
};

export default FirstStepInvoiceDate;
